/* eslint-disable prettier/prettier */
import React, { useState, useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import styles from "./DashboardPage.module.css";
import { useDashboard } from "./useDashboard";
import { useMeetings } from "../CalendarPage/useMeetings";
import { Header } from "../Shared/Header/Header";
import Card from "../Shared/Card";
import MeetingInformationSlider from "./MeetingInformationSlider";
import MeetingControls from "./MeetingControls";
import DiamondListCard from "./DiamondsListCard";
import AgendaListCard from "../Shared/AgendaListCard";
import EditMeetingInfoModal from "../Shared/EditMeetingInfoModal";
import { ReactComponent as CompleteIcon } from "../Shared/CompleteIcon/Complete_Icon.svg";
import dashboardIcon from "../assets/Menu_Icon_Dashboard.svg";
import Auth from "../../shared/@auth";
import moment from "moment";
import { useEffect } from "react";
import { useDocuments } from "ManagementTeam/DocumentsPage/useDocuments";
import { useSettings } from "ManagementTeam/SettingsPage/useSettings";
import DiamondCardModal from "./DiamondCardModal";
import { ReactComponent as NoMeetingIcon } from "../assets/No_Meeting_Scheduled_Graphic.svg";
import { getNameOfTwoDaysMeeting } from "ManagementTeam/utils/meetingDateParse";
import { convertTimeZoneDisplayText } from "ManagementTeam/utils/timezone";
import { getPdfFutureMeeting } from "../utils/getPdfFutureMeeting";
import Button from "shared/Button";
import ProxyCheckmark from "./ProxyCheckmark";
import Loader from "shared/Loader";

/**
 * TODO:
 *  - API REQUESTS
 *      - meetingAgendaLink: needs API update IGNORE FOR NOW
 *      - user specific committees: waiting on Matt reply
 *
 */

export function DashboardPage({ meetingType, isHideInfo, setToggleInfo }) {
  const [refetchInterval, setRefetchInterval] = useState(1000 * 10);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const {
    data: dashboard,
    fetchFile,
    meetingEndPut,
    meetingEndSessionPut,
    meetingCheckInPut,
    status,
    userEditPut,
    userSettingsPut,
    editAgendaPut,
    swapIBOPost,
    refetchDashboard,
    isFetching,
  } = useDashboard(refetchInterval, true, true);

  const { data: settings, getSettings } = useSettings(
    new Date().getUTCFullYear()
  );
  const { downloadFile } = useDocuments();
  const { meetingPut, meetingCheckInProxyGuestsPut } = useMeetings();

  const { account, hasPermission } = Auth.useContainer();
  const email = account.username;
  const currentYear = new Date().getUTCFullYear();
  const [quorum, setQuorum] = useState(0);
  const [showDiamondModal, setShowDiamondModal] = useState(false);
  const [diamondModalInfo, setDiamondModalInfo] = useState(null);
  const [optionDiamonds, setOptionDiamonds] = useState("Alphabetical");
  const [attendanceItem, setAttendanceItem] = useState(null);

  const readOnly = !hasPermission("management-team.admins");

  const handleFetchData = async () => {
    await getSettings(currentYear);
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await Promise.all([refetchDashboard(), getSettings(currentYear)]);
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  useMemo(() => {
    settings && setQuorum(settings.quorum);
  }, [settings]);

  const [_dashboard, setDashboard] = useState(
    dashboard && dashboard.meetings && dashboard.meetings.length > 0
      ? dashboard.meetings
      : []
  );
  const [_guests, setGuests] = useState(
    dashboard && dashboard.guests && dashboard.guests.length > 0
      ? dashboard.guests
      : []
  );
  const [_users, setUsers] = useState(
    dashboard && dashboard.users && dashboard.users.length > 0
      ? dashboard.users
      : []
  );

  const [diamondsList, setDiamondsList] = useState([]);
  const [meetings, setMeetings] = useState([]);
  const [meetingIndex, setMeetingIndex] = useState(0);
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [agendas, setAgendas] = useState([]);

  const [futureMeetingsForEC, setFutureMeetingsForEC] = useState([]);
  const [isGuestProxyCheckIn, setIsGuestProxyCheckIn] = useState(false);
  const [proxyGuestListIds, setProxyGuestListIds] = useState([]);
  useEffect(() => {
    if (meetingType !== "EC") return;

    const meetings = ((dashboard && dashboard.futureMeetings) || []).map((a) =>
      getPdfFutureMeeting(a)
    );

    setFutureMeetingsForEC(meetings);
  }, [dashboard, dashboard.futureMeetings]);

  useMemo(() => {
    dashboard &&
      dashboard.meetings &&
      setDashboard(
        dashboard.meetings.sort(
          (a, b) =>
            new Date(a.dates[0].startsOn) - new Date(b.dates[0].startsOn)
        )
      );
  }, [dashboard]);

  useEffect(() => {
    dashboard &&
      dashboard.guests &&
      setGuests(dashboard.guests ? [...dashboard.guests] : []);
  }, [dashboard, dashboard.guests]);

  useEffect(() => {
    dashboard &&
      dashboard.users &&
      setUsers(dashboard.users ? [...dashboard.users] : []);
  }, [dashboard, dashboard.users]);

  const todayDate = moment().format("DD-MM-YYYY");

  const findArrayElement = (array, date) => {
    return array.find((meeting) => {
      return meeting.startsOn === date;
    });
  };
  const checkChecked = (array, i, type = "attendees") => {
    return array[`${type}`]?.some((e) => (e._id === i._id ? true : false));
  };
  const checkCheckedProxy = (array, i, type = "attendees") => {
    return array[`${type}`]?.some((e) =>
      e._id === i._id && e.proxyCheckInBy ? true : false
    );
  };
  useMemo(() => {
    setMeetings([]);

    if (
      _dashboard !== undefined &&
      _dashboard !== null &&
      _dashboard.length > 0
    ) {
      _dashboard.map((i, index) => {
        const meeting = getPdfFutureMeeting(i);
        setMeetings((prev) => [...prev, meeting]);
        return index;
      });
    }
  }, [_dashboard]);

  const handleSave = (e) => {
    var newDates = [];

    meetingPut.mutate({
      id: _dashboard[meetingIndex]._id,
      meetingType: _dashboard[meetingIndex].meetingType,
      deliveryType: _dashboard[meetingIndex].deliveryType,
      location: _dashboard[meetingIndex].inPerson.location,
      city: _dashboard[meetingIndex].inPerson.city,
      state: _dashboard[meetingIndex].inPerson.state,
      zoomLink: e,
      meetingId: meetings[meetingIndex].virtual.meetingId,
      meetingPasscode: meetings[meetingIndex].virtual.meetingPasscode,
      dates: _dashboard[meetingIndex].dates.map(
        (i) =>
          (newDates[i] = {
            startDate: i.startsOn.substring(0, 10),
            startTime: i.startsOn.substring(11, 19),
            endTime: i.endsOn.substring(11, 19),
            timeZone: i.timeZone,
          })
      ),
      isDraft: true,
    });
  };

  const handleSetDiamonds = (i, todaysMeeting, indexEnded = 0) => {
    setDiamondsList((prev) => [
      ...prev,
      {
        userId: i._id,
        canSwap: i.profileB && i.profileB.firstName ? true : false,
        firstName: i.profile && i.profile.firstName ? i.profile.firstName : "",
        lastName: i.profile && i.profile.lastName ? i.profile.lastName : "",
        photo: i.profile && i.profile.photoUrl ? i.profile.photoUrl : "N/A",
        email: i.profile && i.profile.email ? i.profile.email : "N/A",
        phoneNumber: i.profile && i.profile.phone ? i.profile.phone : "N/A",
        address: i.profile && i.profile.address ? i.profile.address : "N/A",
        spouse: i.profile && i.profile.spouse ? i.profile.spouse : "",
        iboNum: i.iboNumber ? i.iboNumber : "N/A",
        birthdate:
          i.profile && i.profile.birthday
            ? moment.utc(i.profile.birthday).format("MMMM DD, YYYY")
            : "",
        anniversary:
          i.profile && i.profile.anniversary
            ? moment.utc(i.profile.anniversary).format("MMMM DD, YYYY")
            : "",
        uplineDiamond:
          i.businessInfo && i.businessInfo.uplineDiamond
            ? i.businessInfo.uplineDiamond
            : "",
        yearDiamondQualified:
          i.businessInfo && i.businessInfo.yearDiamondQualified
            ? i.businessInfo.yearDiamondQualified
            : "",
        yearQualifyingRequirements:
          i.businessInfo &&
          i.businessInfo.qualifyingRequirementsByYear[0] &&
          i.businessInfo.qualifyingRequirementsByYear[0].year
            ? i.businessInfo.qualifyingRequirementsByYear[0].year
            : 0,
        yearQualified: i.businessInfo
          ? i.businessInfo.yearDiamondQualified
          : "",
        gracePeriod:
          i.businessInfo && i.businessInfo.gracePeriod
            ? i.businessInfo.gracePeriod.isGracePeriod
            : "",

        gracePeriodStarted:
          i.businessInfo &&
          i.businessInfo.gracePeriod &&
          i.businessInfo.gracePeriod.startedOn
            ? moment
                .utc(i.businessInfo.gracePeriod.startedOn)
                .format("MMMM DD, YYYY")
            : "",
        familyReunion: i.eventInfo ? i.eventInfo.hasFamilyReunion : "",
        firstFamilyReunion:
          i.eventInfo && i.eventInfo.firstFamilyReunion
            ? i.eventInfo.firstFamilyReunion
            : "",
        familyReunionAttendance:
          i.eventInfo && i.eventInfo.attendanceAtLastFamilyReunion
            ? i.eventInfo.attendanceAtLastFamilyReunion
            : "",
        votingMemberYear: i.businessInfo
          ? i.businessInfo.yearVotingMemberQualified
          : "",
        pinLevel:
          i.businessInfo &&
          i.businessInfo.qualifyingRequirementsByYear[0] &&
          i.businessInfo.qualifyingRequirementsByYear[0].pinWearing
            ? i.businessInfo.qualifyingRequirementsByYear[0].pinWearing
            : "-",
        garPoints:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0].garPoints
            : 0,
        integratedGarPoints:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0].integratedGarPoints
            : 0,
        diamondRankGar:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0].diamondRankGar
            : 0,
        diamondRankWwg:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0].diamondRankWWG
            : 0,
        capitalShare:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0].capitalShare
            : 0,
        accessLevel: i.accessLevel.includes("EC")
          ? "EC"
          : i.accessLevel.includes("MT1")
          ? "MT1"
          : i.accessLevel.includes("MT2")
          ? "MT2"
          : i.accessLevel.includes("GUEST")
          ? "GUEST"
          : "NONE",
        checkedIn: todaysMeeting
          ? checkChecked(todaysMeeting.dates[indexEnded], i)
          : _dashboard[meetingIndex]
          ? checkChecked(_dashboard[meetingIndex].dates[indexEnded], i)
          : false,
        proxyCheckedIn: todaysMeeting
          ? checkCheckedProxy(todaysMeeting.dates[indexEnded], i)
          : _dashboard[meetingIndex]
          ? checkCheckedProxy(_dashboard[meetingIndex].dates[indexEnded], i)
          : false,
        votingMember:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0].isVotingMember
            : false,
        executiveCommittee:
          i.businessInfo && i.businessInfo.qualifyingRequirementsByYear[0]
            ? i.businessInfo.qualifyingRequirementsByYear[0]
                .isExecutiveCommittee
            : false,
        yearExecutiveCommitteeQualified: i.businessInfo
          ? i.businessInfo.yearExecutiveCommitteeQualified
          : "",

        iboB: i.profileB
          ? {
              ...i.profileB,
              birthday: null,
              birthdate: i.profileB.birthday
                ? moment.utc(i.profileB.birthday).format("MMMM DD, YYYY")
                : "",
              anniversary: i.profileB.anniversary
                ? moment.utc(i.profileB.anniversary).format("MMMM DD, YYYY")
                : "",
            }
          : null,

        //TODO: committees for profileB when IBO B Card is ready
        committees: i.profile.committees,
        committeesB:
          i.profileB && i.profileB.committees ? i.profileB.committees : [],
      },
    ]);
  };
  // dashboard information
  const meetingControls = useMemo(() => {
    setDiamondsList([]);

    if (_dashboard && _dashboard[meetingIndex] !== undefined) {
      var checkCount = 0;
      const todaysMeeting = findArrayElement(
        _dashboard[meetingIndex].dates,
        todayDate
      );
      const indexEnded = todaysMeeting?.dates
        ? todaysMeeting.dates.findIndex((date) => date.sessionEnded) + 1
        : _dashboard[meetingIndex].dates
        ? _dashboard[meetingIndex].dates.findIndex(
            (date) => date.sessionEnded
          ) + 1
        : 0;
      _dashboard[meetingIndex].users
        .filter(
          (user) =>
            user.isDiamond &&
            user.profile.firstName !== "Attorneys" &&
            user.profile.firstName !== "WWG" &&
            user.profile.firstName !== "WWG Guest"
        )
        .map((i, index) => {
          if (meetingType === "MT") {
            if (
              i.isDiamond === true &&
              (i.accessLevel.includes("MT1") || i.accessLevel.includes("MT2"))
            ) {
              handleSetDiamonds(i, todaysMeeting, indexEnded);
              todaysMeeting
                ? todaysMeeting.dates[indexEnded].attendees?.map(
                    (e) => e._id === i._id && checkCount++
                  )
                : _dashboard[meetingIndex].dates[indexEnded].attendees?.map(
                    (e) => e._id === i._id && checkCount++
                  );
            }
          } else if (meetingType === "EC") {
            if (i.isDiamond === true && i.accessLevel.includes("EC")) {
              handleSetDiamonds(i, todaysMeeting, indexEnded);
              todaysMeeting
                ? todaysMeeting.dates[indexEnded].attendees?.map(
                    (e) => e._id === i._id && checkCount++
                  )
                : _dashboard[meetingIndex].dates[indexEnded].attendees?.map(
                    (e) => e._id === i._id && checkCount++
                  );
            }
          }

          return index;
        });
      // meeting controls
      return {
        meetingType: _dashboard[meetingIndex].meetingType,
        currentQuorum: checkCount,
        quorumTotal:
          settings && quorum
            ? quorum
            : _dashboard[meetingIndex]
            ? Math.round(
                _dashboard[meetingIndex].users.filter(
                  (i) =>
                    i.isDiamond &&
                    i.accessLevel.length > 0 &&
                    (i.accessLevel.includes("MT1") ||
                      i.accessLevel.includes("MT2") ||
                      i.accessLevel.includes("EC")) &&
                    !(
                      i.accessLevel.includes("WWG") ||
                      i.accessLevel.includes("ATTORNEY") ||
                      i.accessLevel.includes("ADMIN")
                    )
                ).length * 0.7
              )
            : 0,
        autoCheckInMinutes:
          _dashboard[meetingIndex].checkIn === null ||
          _dashboard[meetingIndex].checkIn === undefined
            ? 0
            : _dashboard[meetingIndex].checkIn.minutesBefore,
        checkIn:
          _dashboard[meetingIndex].checkIn === null ||
          _dashboard[meetingIndex].checkIn === undefined
            ? false
            : _dashboard[meetingIndex].checkIn.isEnabled,
        endSession:
          _dashboard[meetingIndex].endMeeting === null ||
          _dashboard[meetingIndex].checkIn === undefined
            ? false
            : _dashboard[meetingIndex].endMeeting,
        autoCheckIn:
          _dashboard[meetingIndex].checkIn === null ||
          _dashboard[meetingIndex].checkIn === undefined
            ? false
            : _dashboard[meetingIndex].checkIn.autoEnabled,
      };
    } else {
      _users &&
        _users
          .filter(
            (user) =>
              user.isDiamond &&
              user.profile.firstName !== "Attorneys" &&
              user.profile.firstName !== "WWG" &&
              user.profile.firstName !== "WWG Guest"
          )
          .map((i) => {
            if (meetingType === "MT") {
              if (
                i.isDiamond === true &&
                (i.accessLevel.includes("MT1") || i.accessLevel.includes("MT2"))
              ) {
                handleSetDiamonds(i, null);
              }
            } else if (meetingType === "EC") {
              if (i.isDiamond === true && i.accessLevel.includes("EC")) {
                handleSetDiamonds(i, null);
              }
            }
          });
    }

    return {};
  }, [
    _dashboard,
    meetingIndex,
    meetingType,
    settings,
    quorum,
    _users,
    _guests,
  ]);

  // agenda
  useMemo(() => {
    setAgendas([]);
    let userId = "";

    let noteObject = null;
    const onClickPdf = (e) => {
      if (e !== undefined && e.length > 0) {
        fetchFile(e);
      }
    };

    if (_dashboard && _dashboard[meetingIndex] !== undefined) {
      const i = _dashboard[meetingIndex].users.findIndex(
        (e) => e.profile.email !== undefined && e.profile.email === email
      );

      if (i > -1) {
        userId = _dashboard[meetingIndex].users[i]._id;
      }

      if (userId) {
        _dashboard[meetingIndex].agenda
          .filter((item) => !item.isDraft)
          .filter((item) => {
            const indexEnded =
              _dashboard[meetingIndex].dates.findIndex((i) => i.sessionEnded) +
              1;
            if (item.isAttendanceAgenda) {
              if (indexEnded !== item?.dateAttendanceOrder) return false;
            }
            return true;
          })
          .map((i, index) => {
            if (i && i.id) {
              noteObject =
                i.notes && i.notes.length > 0
                  ? i.notes.find((note) => {
                      if (
                        note.postedBy._id.toString() === userId.toString() &&
                        note.location &&
                        note.location.toUpperCase() === "DASHBOARD"
                      )
                        noteObject = note;
                      else noteObject = null;
                      return noteObject;
                    })
                  : null;

              let existingNote = !noteObject ? "" : noteObject.note;
              let existingNoteId = !noteObject ? "" : noteObject._id;

              var yesVote = 0;
              var noVote = 0;

              if (i.choices !== undefined && i.choices?.length > 0)
                i.choices.map(
                  (vote) => (vote.description = "YES" ? yesVote++ : noVote++)
                );

              setAgendas((prev) => [
                ...prev,
                {
                  id: i.id,
                  assignee:
                    i.owner && i.owner.name && !i.owner.name.includes("WWG")
                      ? i.owner.name
                          .split(" ")
                          .map((piece) => capitalizeFirstLetter(piece))
                          .join(" ")
                      : i.owner && i.owner.name
                      ? i.owner.name
                      : "",
                  isAttendanceAgenda: i?.isAttendanceAgenda
                    ? i.isAttendanceAgenda
                    : false,
                  filesAttendance: i?.filesAttendance ? i.filesAttendance : [],
                  isLocked: i.decision?.status && i.decision?.status !== "on",
                  assignedType:
                    i.owner.name.toUpperCase().includes("PAUL TSIKA") ||
                    i.owner.name.includes("Attorneys")
                      ? "Attorney"
                      : i.owner.name.includes("WWG") ||
                        i.owner.name.includes("WWG Guest")
                      ? "WWG"
                      : "Diamond",
                  title: i.title,
                  description: i.description,
                  isNew: false,
                  isCompleted: i.isComplete,
                  hasChoices:
                    i.decision &&
                    i.decision?.choices &&
                    i.decision?.choices?.length > 0,
                  votingStatus:
                    i.decision.status === "on"
                      ? "Voting in Progress"
                      : i.decision.status === "off"
                      ? "Upcoming"
                      : i.decision.votingStatus,
                  onSaveNote: (newNote) =>
                    handleAddEditNote(newNote, existingNoteId, i),
                  onDeleteNote: () => handleDeleteNote(existingNoteId, i), // placeholder until update
                  note: existingNote,
                  pdfName:
                    i.document && i.document.files.length > 0
                      ? i.document.files[0].name
                      : "",
                  onClickPdf:
                    i.document && i.document.files.length > 0
                      ? () => downloadFile(i.document.files[0].downloadPath)
                      : () => console.log("no file found"),
                  onClickAttendancePdf:
                    i.filesAttendance && i.filesAttendance.length > 0
                      ? () => downloadFile(i.filesAttendance[0].downloadPath)
                      : () => console.log("no file found"),
                },
              ]);
              return index;
            }
          });
      }

      const indexEnded = _dashboard[meetingIndex]?.dates
        ? _dashboard[meetingIndex].dates.findIndex(
            (date) => date.sessionEnded
          ) + 1
        : 0;
      setAttendanceItem({
        attendees: _dashboard[meetingIndex].dates[indexEnded].attendees,
        guestAttendees: _dashboard[meetingIndex].dates[indexEnded].guests,
        users: _dashboard[meetingIndex].users,
        quorum: settings?.quorum || 0,
        meetingDate: _dashboard[meetingIndex].dates,
        meetingLocation: _dashboard[meetingIndex].inPerson
          ? _dashboard[meetingIndex].inPerson
          : null,
        guests: _dashboard[meetingIndex].guests,
        fontFamily: "Myriad Pro",
        meetingType: _dashboard[meetingIndex].meetingType,
      });
    }
  }, [_dashboard, meetingIndex, email]);

  async function updateCheckinPut(meetingControls) {
    if (
      _dashboard &&
      _dashboard[meetingIndex] !== undefined &&
      Object.keys(meetingControls).length > 0
    ) {
      setDashboard((prev) => {
        let data = [...prev];
        data[meetingIndex].checkIn = {
          ...data[meetingIndex].checkIn,
          isEnabled: meetingControls.checkIn,
          autoEnabled: meetingControls.autoCheckIn,
          minutesBefore:
            meetingControls.autoCheckInMinutes === ""
              ? 0
              : parseInt(meetingControls.autoCheckInMinutes),
        };
        return data;
      });

      const checkInObject = {
        id: _dashboard[meetingIndex].id,
        checkIn: {
          isEnabled: meetingControls.checkIn,
          autoEnabled: meetingControls.autoCheckIn,
          minutesBefore:
            meetingControls.autoCheckInMinutes === ""
              ? 0
              : parseInt(meetingControls.autoCheckInMinutes),
        },
      };
      meetingCheckInPut.mutate(checkInObject);
    }
  }

  async function onSwapIBO(e) {
    setShowDiamondModal(false);

    swapIBOPost.mutateAsync(e.userId).then(async () => {
      await refetchDashboard();
    });
  }

  async function handleUserSave(e) {
    var data = e.picture;
    var mimeType = data.substring("data:".length, data.indexOf(";base64"));
    const user = diamondsList.find((a) => a.userId === e.userId);

    var dataB = e.iboB && e.iboB.photoUrl ? e.iboB.photoUrl : null;
    var mimeTypeB =
      dataB &&
      dataB.length > 0 &&
      dataB.substring("data:".length, dataB.indexOf(";base64"));

    if (user) {
      user.iboNum = e.iboNum;
      user.accessLevel = e.accessLevel;
      user.spouse = e.spouse;
      user.birthdate = e.birthdate;
      user.anniversary = e.anniversary;
      user.uplineDiamond = e.uplineDiamond;
      user.yearDiamondQualified = e.yearDiamondQualified;
      user.gracePeriod = e.gracePeriod;
      user.gracePeriodStarted = e.gracePeriodStarted;
      user.familyReunion = e.familyReunion;
      user.firstFamilyReunion = e.firstFamilyReunion;
      user.familyReunionAttendance = e.familyReunionAttendance;
      setDiamondsList(diamondsList);
    }

    userEditPut.mutate(
      {
        userId: e.userId,
        iboNumber: e.iboNum,
        accessLevel: e.accessLevel,
        profile: {
          spouse: e.spouse,
          birthday: e.birthdate,
          anniversary: e.anniversary,
          ...(e.isPhotoChanged && {
            photoUrl: {
              name: "New Profile Picture",
              data: data,
              mimetype: mimeType,
            },
          }),
        },
        businessInfo: {
          uplineDiamond: e.uplineDiamond,
          yearVotingMemberQualified: e.votingMemberYear,
          yearExecutiveCommitteeQualified: e.yearExecutiveCommitteeQualified,
        },
        gracePeriod: {
          isGracePeriod: e.gracePeriod,
          startedOn: e.gracePeriodStarted,
        },
        eventInfo: {
          hasFamilyReunion: e.familyReunion,
          firstFamilyReunion: e.firstFamilyReunion,
          attendanceAtLastFamilyReunion: e.familyReunionAttendance,
        },
        profileB: {
          ...e.iboB,
          ...(e.isPhotoBChanged && {
            photoUrl: dataB
              ? {
                  name: "New Profile Picture",
                  data: dataB,
                  mimetype: mimeTypeB,
                }
              : null,
          }),
        },
      },
      {
        onSettled: () => {
          refetchDashboard();
        },
      }
    );

    // TODO: Add API to Edit User Committees After API Update
  }

  const handleAddEditNote = (newNote, existingNoteId, agenda) => {
    // Ensure notes is always an array
    if (!agenda.notes) {
      agenda.notes = [];
    }

    if (existingNoteId) {
      for (let index = 0; index < agenda.notes.length; index++) {
        if (agenda.notes[index]._id.toString() === existingNoteId.toString()) {
          agenda.notes[index].note = newNote;
          break;
        }
      }
    } else {
      agenda.notes.push({
        note: newNote,
        postedBy: {
          name: account.name,
          _id: _dashboard[0].users.find(
            (user) => user.profile.email === account.username
          )._id,
        },
        location: "DASHBOARD", //self
      });
    }

    editAgendaPut.mutate({
      meetingId: _dashboard[meetingIndex].id,
      agendaId: agenda.id,
      owner: agenda.owner,
      title: agenda.title,
      description: agenda.description,
      notes: agenda.notes,
    });
  };

  const handleDeleteNote = (existingNoteId, agenda) => {
    // Ensure notes is always an array before filtering
    if (!agenda.notes) {
      agenda.notes = [];
    }

    agenda.notes = agenda.notes.filter((note) => note._id !== existingNoteId);

    editAgendaPut.mutate({
      meetingId: _dashboard[meetingIndex].id,
      agendaId: agenda.id,
      owner: agenda.owner,
      title: agenda.title,
      description: agenda.description,
      notes: agenda.notes,
    });
  };

  const capitalizeFirstLetter = (string) => {
    var _string = string.toLowerCase();
    return _string.charAt(0).toUpperCase() + _string.slice(1);
  };

  const onClickProfile = (diamondModalInfo) => {
    setShowDiamondModal(!showDiamondModal);
    setDiamondModalInfo(diamondModalInfo);
  };
  const getPdfDate = (meeting) => {
    let dateString =
      meeting?.dates && meeting.dates.length > 0
        ? meeting.dates.map((date) =>
            moment.utc(date.startsOn).format("MMMM DD, YYYY")
          )
        : [];
    return dateString.length === 2
      ? getNameOfTwoDaysMeeting(dateString)
      : dateString[0];
  };
  const isAutoCheckedAvailable = useMemo(() => {
    if (
      meetings[meetingIndex]?.checkIn?.autoEnabled &&
      meetings[meetingIndex].datesAttendees[0]
    ) {
      const indexEnded = meetings[meetingIndex].datesAttendees
        ? meetings[meetingIndex].datesAttendees.findIndex(
            (date) => date.sessionEnded
          ) + 1
        : 0;
      const meetingTime = new Date(
        meetings[meetingIndex]?.datesAttendees[indexEnded]
      );
      const checkInTime = new Date(
        meetingTime.getTime() -
          (meetings[meetingIndex].checkIn?.minutesBefore
            ? meetings[meetingIndex].checkIn?.minutesBefore * 60 * 1000
            : 15 * 60 * 1000)
      );
      const currentTime = new Date(Date.now());
      if (
        currentTime.getTime() > checkInTime.getTime() &&
        currentTime.getTime() < meetingTime.getTime()
      )
        return true;
    }
    return false;
  }, [meetings, meetingIndex, isFetching]);
  useEffect(() => {
    if (meetingControls.autoCheckIn) {
      let newMeetingControls = {
        ...meetingControls,
        checkIn: isAutoCheckedAvailable,
      };

      updateCheckinPut(newMeetingControls);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAutoCheckedAvailable, isFetching]);

  const isGuestCheckin = (guest) => {
    if (_dashboard.length == 0) {
      return false;
    }
    const todaysMeeting = findArrayElement(
      _dashboard[meetingIndex].dates,
      todayDate
    );
    const indexEnded = todaysMeeting?.dates
      ? todaysMeeting.dates.findIndex((date) => date.sessionEnded) + 1
      : _dashboard[meetingIndex].dates
      ? _dashboard[meetingIndex].dates.findIndex((date) => date.sessionEnded) +
        1
      : 0;
    const currentDate = todaysMeeting
      ? todaysMeeting.dates[indexEnded]
      : _dashboard[meetingIndex]
      ? _dashboard[meetingIndex].dates[indexEnded]
      : null;

    return checkCheckedProxy(currentDate, guest, "guests")
      ? 2
      : checkChecked(currentDate, guest, "guests")
      ? 1
      : 0;
  };

  useEffect(() => {
    const listGuest =
      _dashboard[meetingIndex] &&
      _dashboard[meetingIndex].guests &&
      _dashboard[meetingIndex].guests.length > 0
        ? _dashboard[meetingIndex].guests
        : _guests && _guests.length > 0
        ? _guests
        : null;
    const ids = listGuest
      ?.filter((guest) => {
        return isGuestCheckin(guest) === 2;
      })
      .map((g) => g._id);
    setProxyGuestListIds(ids);
  }, [_dashboard, _guests, meetingIndex]);

  const renderGuestList = useMemo(() => {
    const listGuest =
      _dashboard[meetingIndex] &&
      _dashboard[meetingIndex].guests &&
      _dashboard[meetingIndex].guests.length > 0
        ? _dashboard[meetingIndex].guests
        : _guests && _guests.length > 0
        ? _guests
        : [];

    // Append admin check in to list of guest to show
    if (_dashboard[meetingIndex]) {
      const indexEnded = _dashboard[meetingIndex].dates
        ? _dashboard[meetingIndex].dates.findIndex(
            (date) => date.sessionEnded
          ) + 1
        : 0;
      const currentDate = _dashboard[meetingIndex]
        ? _dashboard[meetingIndex].dates[indexEnded]
        : null;
      currentDate?.guests.forEach((i) => {
        if (listGuest.findIndex((g) => g._id === i._id) === -1) {
          listGuest.push(i);
        }
      });
    }

    return listGuest.map((guest, index) => (
      <div key={index} className={styles.guestInfo}>
        {isGuestCheckin(guest) === 2 ||
        proxyGuestListIds?.includes(guest._id) ? (
          <ProxyCheckmark />
        ) : isGuestCheckin(guest) === 1 ? (
          <CompleteIcon />
        ) : (
          false
        )}
        <p className={styles.guestButton}>
          <span>
            {guest.name
              .split(" ")
              .map((name) => capitalizeFirstLetter(name))
              .join(" ")}
          </span>
          {isGuestProxyCheckIn &&
            !proxyGuestListIds?.includes(guest._id) &&
            isGuestCheckin(guest) === 0 && (
              <Button
                key={index}
                children="Check In"
                className={styles.checkButton}
                onClick={() => {
                  const payload = {
                    id: meetings[meetingIndex]?.id,
                    proxyUsers: [guest._id],
                  };
                  meetingCheckInProxyGuestsPut.mutateAsync(payload);
                  setProxyGuestListIds([...proxyGuestListIds, guest._id]);
                }}
              />
            )}
        </p>
      </div>
    ));
  }, [
    _dashboard,
    _guests,
    meetingIndex,
    isGuestProxyCheckIn,
    proxyGuestListIds,
  ]);
  return (
    <div className={styles.container}>
      {meetings.length > 0 && (
        <EditMeetingInfoModal
          isOpen={showMeetingModal}
          onClose={() => setShowMeetingModal(!showMeetingModal)}
          years={meetings[meetingIndex].years}
          days={meetings[meetingIndex].days}
          months={meetings[meetingIndex].months}
          location={meetings[meetingIndex].location}
          city={meetings[meetingIndex].city}
          state={meetings[meetingIndex].state}
          building={meetings[meetingIndex].building}
          time={meetings[meetingIndex].time}
          zoomLink={meetings[meetingIndex].virtual.zoomLink}
          meetingId={meetings[meetingIndex].virtual.meetingId}
          meetingPasscode={meetings[meetingIndex].virtual.meetingPasscode}
          addToCalender={() => console.log("ask about mobile calendar add")} // need api or does it exist?
          isInPerson={meetings[meetingIndex].isInPerson}
          isVirtual={meetings[meetingIndex].isVirtual}
          onSave={(e) => handleSave(e)}
          readonly={true}
        />
      )}
      <div className={styles.header}>
        <Header
          title={"Dashboard"}
          icon={dashboardIcon}
          children={<></>}
          isLock={true}
          isHide={isHideInfo}
          setToggleInfo={setToggleInfo}
          onRefresh={handleRefresh}
          isLoading={isRefreshing}
        />
      </div>
      <div className={styles.content}>
        {status === "loading" ? (
          <div className={styles.loading}>
            <Loader />
          </div>
        ) : status === "error" ? (
          <div className={styles.loading}>
            Error, please contact support or try again later.
          </div>
        ) : (
          <>
            <div className={styles.row}>
              <div
                className={`${styles.item} ${styles.controls} ${
                  styles[`card${meetingType}`]
                }`}
              >
                <Card
                  header="Meeting Controls"
                  children={
                    _dashboard && meetings.length > 0 ? (
                      <div className={styles.meetingControls}>
                        <div className={styles.controlItem}>
                          <MeetingInformationSlider
                            meetings={meetings}
                            onClick={() =>
                              setShowMeetingModal(!showMeetingModal)
                            }
                            onArrowClick={(e) => {
                              setDiamondsList([]);
                              setMeetingIndex((prev) => prev + e);
                            }}
                          />
                        </div>
                        <div className={styles.controlItem}>
                          <MeetingControls
                            dates={meetings[meetingIndex].datesAttendees}
                            meetingType={meetingControls.meetingType}
                            checkedIn={meetingControls.checkIn}
                            endSession={meetingControls.endSession}
                            autoCheckIn={meetingControls.autoCheckIn}
                            autoCheckInMinutes={
                              meetingControls.autoCheckInMinutes
                            }
                            currentQuorum={meetingControls.currentQuorum}
                            quorumTotal={meetingControls.quorumTotal}
                            setCheckedIn={(e) => {
                              let newMeetingControls = {
                                ...meetingControls,
                                checkIn: !meetingControls.checkIn,
                              };

                              updateCheckinPut(newMeetingControls);
                            }}
                            setEndSession={(endedMeeting, indexEnded) => {
                              if (endedMeeting) {
                                meetingEndPut.mutateAsync({
                                  id: _dashboard[meetingIndex].id,
                                  endSession: !meetingControls.endSession,
                                });
                              } else {
                                meetingEndSessionPut.mutateAsync({
                                  id: _dashboard[meetingIndex].id,
                                  endSession: !meetingControls.endSession,
                                  indexEnded: indexEnded,
                                });
                              }
                              setDashboard((prev) => {
                                let data = [...prev];
                                data[meetingIndex] = {
                                  ...data[meetingIndex],
                                  endMeeting: !meetingControls.endSession,
                                };
                                return data;
                              });
                              refetchDashboard();
                            }}
                            setAutoCheckIn={() => {
                              let newMeetingControls = {
                                ...meetingControls,
                                checkIn: false,
                                autoCheckIn: !meetingControls.autoCheckIn,
                              };
                              updateCheckinPut(newMeetingControls);
                            }}
                            setAutoCheckInMinutes={(e) => {
                              let newMeetingControls = {
                                ...meetingControls,
                                autoCheckInMinutes: e,
                              };
                              updateCheckinPut(newMeetingControls);
                            }}
                          />
                        </div>
                      </div>
                    ) : (
                      <div className={styles.noMeeting}>
                        <NoMeetingIcon />
                      </div>
                    )
                  }
                />
              </div>

              {/* {_dashboard[meetingIndex] !== undefined &&
              _dashboard[meetingIndex] !== null &&
              _dashboard[meetingIndex].admins.length > 0 ? (
                <div
                  className={`${styles.item} ${styles.admins} ${
                    styles[`card${meetingType}`]
                  }`}
                >
                  <Card
                    header="Admins Logged In"
                    children={
                      _dashboard[meetingIndex] !== undefined &&
                      _dashboard[meetingIndex] !== null &&
                      _dashboard[meetingIndex].admins.length > 0
                        ? _dashboard[meetingIndex].admins.map(
                            (admin, index) => (
                              <div key={index} className={styles.adminInfo}>
                                <p>{admin.name}</p>
                                <p>{admin.viewing}</p>
                              </div>
                            )
                          )
                        : null
                    }
                  />
                </div>
              ) : null} */}
              <div
                className={`${styles.item} ${styles.admins} ${
                  styles[`card${meetingType}`]
                }`}
              >
                <Card
                  header="Guest Access"
                  btnTitle={isGuestProxyCheckIn ? "Done" : "Proxy Check In"}
                  onClick={() => {
                    setRefetchInterval(
                      !isGuestProxyCheckIn ? false : 1000 * 10
                    );
                    if (isGuestProxyCheckIn) refetchDashboard();
                    setIsGuestProxyCheckIn(!isGuestProxyCheckIn);
                  }}
                  children={renderGuestList}
                  readOnly={readOnly}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.column1}>
                <div
                  className={`${styles.item} ${styles.agenda} ${
                    styles[`card${meetingType}Agenda`]
                  }`}
                >
                  <AgendaListCard
                    key={_dashboard[meetingIndex]?.id}
                    meetingId={_dashboard[meetingIndex]?.id}
                    isCheckedIn={
                      _dashboard[meetingIndex]?.isCurrentAdminCheckedIn
                    }
                    agendaItems={agendas}
                    meetingAgendaLink={""} // placeholder, need update
                    meetings={meetings}
                    date={getPdfDate(_dashboard[meetingIndex])}
                    attendanceItem={attendanceItem}
                    meetingType={meetingType}
                    currentMeetingInfo={_dashboard[meetingIndex]}
                    futureMeetingsForEC={futureMeetingsForEC}
                    currentMeetingDate={{
                      dates:
                        _dashboard[meetingIndex]?.dates &&
                        _dashboard[meetingIndex].dates.length > 0
                          ? _dashboard[meetingIndex].dates.map((date) =>
                              moment.utc(date.startsOn).format("MMMM DD, YYYY")
                            )
                          : [],
                    }}
                  />
                </div>
              </div>
              <div className={styles.column2}>
                <div
                  className={`${styles.item} ${styles.diamonds} ${
                    styles[`card${meetingType}`]
                  }`}
                >
                  <DiamondListCard
                    meetingId={meetings[meetingIndex]?.id}
                    diamonds={diamondsList}
                    onClickProfile={(diamondModalInfo) =>
                      onClickProfile(diamondModalInfo)
                    }
                    option={optionDiamonds}
                    setOption={setOptionDiamonds}
                    isHideInfo={isHideInfo}
                  />
                  {showDiamondModal && diamondModalInfo !== null && (
                    <div className={styles.diamondCardModal}>
                      <DiamondCardModal
                        diamondInfo={diamondModalInfo}
                        isOpen={showDiamondModal}
                        onClose={() => onClickProfile(null)}
                        onSwap={(diamondModalInfo) => {
                          onSwapIBO(diamondModalInfo);
                        }}
                        onSave={async (e) => {
                          await handleUserSave(e);
                          setTimeout(() => {
                            refetchDashboard();
                          }, 2000);
                        }}
                        isHideInfo={isHideInfo}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
